import { Config } from '@leverege/plugin'
import { Toast } from '@leverege/ui-elements'

export default {
  id : 'ps.action.CopyEventEndImageUrl',
  matches : {
    client : 'LinearViewBlock'
  },
  layout : {
    group : [ 'Image', 'End' ],
    groupIcons : [ 'fa fa-fw fa-camera' ]
  },
  appearance : () => ( {
    name : 'Copy',
    icon : 'fa fa-fw fa-copy'
  } ),
  handles : ( context ) => {
    const { item } = context
    
    return item?.stopData != null
  },
  perform : ( { context } ) => {
    const { item } = context
    const imageBucketUrl = Config.get( 'LinearViewBlock', 'gcsImageBucketUrl' )
    navigator.clipboard.writeText( `${imageBucketUrl}/${item.stopData.imagePath}` )
    Toast.success( 'Copied to clipboard!' )
  }
}
